import { render, staticRenderFns } from "./VideoReunies.vue?vue&type=template&id=d289a1ae&"
import script from "./VideoReunies.vue?vue&type=script&lang=js&"
export * from "./VideoReunies.vue?vue&type=script&lang=js&"
import style0 from "./VideoReunies.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports